module.exports = __webpack_public_path__ + "static/wave_1-5f68c89aeb4e1518f0cbaca1b81ce51f.webp";